import React from "react";
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';

import './styles.css';

const IoT = () => {
  return (
    <>
      <Card className="text-center">
        <Card.Header><div className="opcoes">Crescimento exponencial dos Dispositivos IoT</div></Card.Header>
        <Card.Body>
          <Card.Title><div className="opcoes">A internet das coisas</div></Card.Title>
          <Card.Text>
          <div className="opcoes">A realidade é que os dispositivos IoT são amplamente usados 
            e são essenciais para o desenvolvimento das casas inteligentes.  
            Dispositivos IoT comuns no Brasil incluem, smart tv, smart speakers(Alexa), câmeras de segurança, 
            paineis solares, ar-condicionado, lâmpadas Wi-Fi e fechaduras inteligentes.</div>         
          </Card.Text>
          {/* <Button variant="primary">Go somewhere</Button> */}
        </Card.Body>
        <Card.Footer className="text-muted"><div className="opcoes">A automação residencial e a segurança são áreas em crescimento, exigindo conexões estáveis e seguras.</div></Card.Footer>
      </Card>
    </>
  )
}
export default IoT;